/**
 * How a chosen row looks in the partner pickers.
 *
 * These lists are all "pick exactly one", so the chosen row has to be obvious
 * at a glance - otherwise an operator clicks a partner, sees nothing change,
 * and presses a button naming a record they never knowingly chose.
 *
 * `--bg-subtle` (#f5f3ef), NOT `--bg-light` (#fffffffa - white at 98% alpha,
 * invisible on a white dialog). That mistake shipped three times before anyone
 * could see it, which is why this lives in one file.
 *
 * One definition, because the same picker appears in regroup, move access, and
 * the invite dialog's parent picker.
 */
export const ROW_SELECTED = 'bg-[var(--bg-subtle)] text-[var(--ink)] font-medium'

/** Nothing to draw - the row is only distinguished by the fill above. */
export const ROW_UNSELECTED = ''

/** For a radio-style pair, where the whole control should read as chosen. */
export const CHOICE_SELECTED =
  'bg-[var(--bg-subtle)] border-[var(--green)] ring-1 ring-[var(--green)] text-[var(--ink)]'
